"use strict";
var React = require('react')
var NewsStore = require('../../store/NewsStore')
var getAdAction = require('../../actions/getAdAction');
var Link = require('react-router').Link
var _ = require('underscore')
var ListItemNews = React.createClass({
  componentWillMount(){
    //getAdAction.getAdlist(this.props.listType);
  },
    componentDidMount() {
        NewsStore.addChangeListener(this.onChange);
    },
    componentWillUnmount() {
        NewsStore.removeChangeListener(this.onChange);
    },
    getInitialState() {
        var state = this.props.listType === "ad" ? NewsStore.getAd() : NewsStore.getGod_izv()
        return state;
    },
    onChange() {
        var state = this.props.listType === "ad" ? NewsStore.getAd() : NewsStore.getGod_izv()
        this.setState(state);
    },
    list(){
      var numb = this.props.limit === "false" ? 100 : this.props.limit
      var path = this.props.listType === "ad" ? "/akcionarsko-drustvo/" : "/vazna-dokumenta/";
      var listItems = _.map(this.state.data, function(news, index){
        return ( index < numb  ? <Link to={path+news.pdf} className="list-group-item " key={index}><h5 className="list-group-item-heading">{news.tekst}</h5></Link> : null )
      })
      return(listItems);
    },
  render: function() {

    return (
    <div>

        <div className="list-group">
        <a href="#" className="list-group-item active">{this.props.title}</a>
        {this.list()}
        </div>

    </div>
    )
  }
});

module.exports=ListItemNews;




/** WEBPACK FOOTER **
 ** ./modules/components/App/ListItemNews.js
 **/